var FormViewRequest = function FormViewRequest() {
  this.FirstQuery = true;
  this.ValueSet = {};
  this.AttributeSet = {};
  this.Action = "";
};

export default FormViewRequest;